"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.BmiCalculator = exports.WeightUnit = exports.LengthUnit = exports.UnitType = exports.BmiClass = void 0;

require("antd/lib/table/style");

var _table = _interopRequireDefault(require("antd/lib/table"));

require("antd/lib/card/style");

var _card = _interopRequireDefault(require("antd/lib/card"));

require("antd/lib/statistic/style");

var _statistic = _interopRequireDefault(require("antd/lib/statistic"));

require("antd/lib/slider/style");

var _slider = _interopRequireDefault(require("antd/lib/slider"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

require("antd/lib/radio/style");

var _radio = _interopRequireDefault(require("antd/lib/radio"));

require("antd/lib/form/style");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _react = _interopRequireWildcard(require("react"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _bmi = require("../calculations/bmi");

var _Core = require("../../../../components/Core");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp;

var FormItem = _form.default.Item;
var RadioGroup = _radio.default.Group; // import { Gender } from '../data/Gender';

function assertUnreachable(message) {
  throw new Error(message);
}

var BmiClass;
exports.BmiClass = BmiClass;

(function (BmiClass) {
  BmiClass[BmiClass["UnderweightSevere"] = 0] = "UnderweightSevere";
  BmiClass[BmiClass["UnderweightModerate"] = 1] = "UnderweightModerate";
  BmiClass[BmiClass["UnderweightMild"] = 2] = "UnderweightMild";
  BmiClass[BmiClass["Normal"] = 3] = "Normal";
  BmiClass[BmiClass["Overweight"] = 4] = "Overweight";
  BmiClass[BmiClass["Obese1"] = 5] = "Obese1";
  BmiClass[BmiClass["Obese2"] = 6] = "Obese2";
  BmiClass[BmiClass["Obese3"] = 7] = "Obese3";
})(BmiClass || (exports.BmiClass = BmiClass = {}));

var UnitType;
exports.UnitType = UnitType;

(function (UnitType) {
  UnitType[UnitType["Metric"] = 1] = "Metric";
  UnitType[UnitType["Imperial"] = 2] = "Imperial";
})(UnitType || (exports.UnitType = UnitType = {}));

var LengthUnit;
exports.LengthUnit = LengthUnit;

(function (LengthUnit) {
  LengthUnit[LengthUnit["cm"] = 1] = "cm";
  LengthUnit[LengthUnit["in"] = 2] = "in";
})(LengthUnit || (exports.LengthUnit = LengthUnit = {}));

var WeightUnit;
exports.WeightUnit = WeightUnit;

(function (WeightUnit) {
  WeightUnit[WeightUnit["kg"] = 1] = "kg";
  WeightUnit[WeightUnit["lb"] = 2] = "lb";
})(WeightUnit || (exports.WeightUnit = WeightUnit = {}));

function convertLength(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) {
    return value;
  }

  switch (toUnit) {
    case LengthUnit.cm:
      switch (fromUnit) {
        case LengthUnit.in:
          return convertInchesToCm(value);

        default:
          break;
      }

    case LengthUnit.in:
      switch (fromUnit) {
        case LengthUnit.cm:
          return convertCmToInches(value);

        default:
          break;
      }

    default:
      assertUnreachable("Unexpected Unit: " + toUnit);
  }
}

function convertWeight(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) {
    return value;
  }

  switch (toUnit) {
    case WeightUnit.kg:
      switch (fromUnit) {
        case WeightUnit.lb:
          return convertPoundsToKg(value);

        default:
          break;
      }

    case WeightUnit.lb:
      switch (fromUnit) {
        case WeightUnit.kg:
          return convertKgToPounds(value);

        default:
          break;
      }

    default:
      assertUnreachable("Unexpected Unit: " + toUnit);
  }
}

var CmInchConversionFactor = 2.54; // centimetres to inches

function convertCmToInches(cm) {
  return cm / CmInchConversionFactor;
} // inches to centimetres


function convertInchesToCm(inches) {
  return inches * CmInchConversionFactor;
}

var KgLbsConversionFactor = 0.453592; // kilograms to pounds

function convertKgToPounds(kg) {
  return kg / KgLbsConversionFactor;
} // pounds to kilograms


function convertPoundsToKg(pounds) {
  return pounds * KgLbsConversionFactor;
}

function bmiLabel(bmiClass) {
  switch (bmiClass) {
    case BmiClass.UnderweightSevere:
      return "Severe thinness";

    case BmiClass.UnderweightModerate:
      return "Moderate thinness";

    case BmiClass.UnderweightMild:
      return "Mild thinness";

    case BmiClass.Normal:
      return "Normal range";

    case BmiClass.Overweight:
      return "Overweight";

    case BmiClass.Obese1:
      return "Obese class 1";

    case BmiClass.Obese2:
      return "Obese class 2";

    case BmiClass.Obese3:
      return "Obese class 3";

    default:
      break;
  }
}

function bmiClassification(bmi) {
  if (bmi < 16) {
    return BmiClass.UnderweightSevere;
  } else if (bmi >= 16 && bmi < 17) {
    return BmiClass.UnderweightModerate;
  } else if (bmi >= 17 && bmi < 18.5) {
    return BmiClass.UnderweightMild;
  } else if (bmi >= 18.5 && bmi < 25) {
    return BmiClass.Normal;
  } else if (bmi >= 25 && bmi < 30) {
    return BmiClass.Overweight;
  } else if (bmi >= 30 && bmi < 35) {
    return BmiClass.Obese1;
  } else if (bmi >= 35 && bmi < 40) {
    return BmiClass.Obese2;
  } else if (bmi >= 40) {
    return BmiClass.Obese3;
  }
} // interface Range {
//   min?: number;
//   max?: number;
// }


function bmiRange(bmiClass) {
  switch (bmiClass) {
    case BmiClass.UnderweightSevere:
      return "Below 16";

    case BmiClass.UnderweightModerate:
      return "16 - below 17";

    case BmiClass.UnderweightMild:
      return "17 - below 18.5";

    case BmiClass.Normal:
      return "18.5 - below 25";

    case BmiClass.Overweight:
      return "25 - below 30";

    case BmiClass.Obese1:
      return "30 - below 35";

    case BmiClass.Obese2:
      return "35 - below 40";

    case BmiClass.Obese3:
      return "Above 40";

    default:
      break;
  }
}

function createRowData(bmiClass) {
  return {
    key: bmiClass,
    range: bmiRange(bmiClass),
    label: bmiLabel(bmiClass)
  };
}

var BmiCalculator = (0, _mobxReact.observer)(_class = (_class2 = (_temp =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(BmiCalculator, _Component);

  function BmiCalculator() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _initializerDefineProperty2.default)(_this, "height", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "weight", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "heightCm", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "weightKg", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "unit", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "unitChange", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "heightChange", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "weightChange", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = BmiCalculator.prototype; // meterClick = () => {
  //
  // }

  _proto.render = function render() {
    return _react.default.createElement(_Core.Box, {
      mb: 4
    }, _react.default.createElement("dl", null, _react.default.createElement("dt", null, "Gender"), _react.default.createElement("dd", null, "Male versus Female is not used by World Health Organisation BMI classification")), _react.default.createElement(_form.default, {
      layout: "vertical"
    }, _react.default.createElement(_card.default, null, _react.default.createElement(FormItem, {
      label: "Unit"
    }, _react.default.createElement(RadioGroup, {
      onChange: this.unitChange,
      value: this.unit
    }, _react.default.createElement(_radio.default, {
      key: "metric",
      name: "unit",
      checked: this.unit === UnitType.Metric,
      value: UnitType.Metric
    }, "Metric"), _react.default.createElement(_radio.default, {
      key: "imperial",
      name: "unit",
      checked: this.unit === UnitType.Imperial,
      value: UnitType.Imperial
    }, "Imperial"))), _react.default.createElement(FormItem, {
      label: "Height",
      extra: this.heightDisplay
    }, _react.default.createElement(_slider.default, {
      min: this.heightValues.min,
      max: this.heightValues.max,
      onChange: this.heightChange,
      value: this.height
    })), _react.default.createElement(FormItem, {
      label: "Weight",
      extra: this.weightDisplay
    }, _react.default.createElement(_slider.default, {
      min: this.weightValues.min,
      max: this.weightValues.max,
      onChange: this.weightChange,
      value: this.weight
    })), _react.default.createElement(_statistic.default, {
      valueStyle: {
        fontSize: "xx-large",
        color: "purple"
      },
      title: "BMI",
      value: this.bmi
    }))), _react.default.createElement(_table.default, {
      rowSelection: {
        selectedRowKeys: [this.bmiClass],
        hideDefaultSelections: true
      },
      dataSource: this.bmiClassRows,
      pagination: false
    }, _react.default.createElement(_table.default.Column, {
      key: "bmiRange",
      title: "BMI Range",
      dataIndex: "range"
    }), _react.default.createElement(_table.default.Column, {
      key: "classification",
      title: "Classification",
      dataIndex: "label"
    })));
  };

  (0, _createClass2.default)(BmiCalculator, [{
    key: "heightValues",
    // @computed get heightCm() {
    // }
    get: function get() {
      switch (this.unit) {
        case UnitType.Imperial:
          return {
            unitType: LengthUnit.in,
            unitLabel: "in",
            min: 20,
            max: 110
          };

        case UnitType.Metric:
          return {
            unitType: LengthUnit.cm,
            unitLabel: "cm",
            min: 50,
            max: 280
          };

        default:
          throw Error("Unexpected unit: " + this.unit);
      }
    }
  }, {
    key: "weightValues",
    get: function get() {
      switch (this.unit) {
        case UnitType.Imperial:
          return {
            unitType: WeightUnit.lb,
            unitLabel: "lb",
            min: 44,
            max: 397
          };

        case UnitType.Metric:
          return {
            unitType: WeightUnit.kg,
            unitLabel: "kg",
            min: 20,
            max: 180
          };

        default:
          throw Error("Unexpected unit: " + this.unit);
      }
    } // @computed get lengthUnit(): LengthUnit {
    //   switch (this.unit) {
    //     case Unit.Imperial:
    //       return LengthUnit.in;
    //     case Unit.Metric:
    //       return LengthUnit.cm;
    //     default:
    //       throw Error(`Unexpected length unit: ${this.unit}`);
    //   }
    // }
    // @computed get lengthDisplayUnit(): string {
    //   switch (this.unit) {
    //     case Unit.Imperial:
    //       return 'in';
    //     case Unit.Metric:
    //       return 'cm';
    //     default:
    //       throw Error(`Unexpected length unit: ${this.unit}`);
    //   }
    // }

  }, {
    key: "heightDisplay",
    get: function get() {
      // return `Height (${this.lengthDisplayUnit})`;
      return this.height + " (" + this.heightValues.unitLabel + ")";
    }
  }, {
    key: "weightDisplay",
    get: function get() {
      return this.weight + " (" + this.weightValues.unitLabel + ")";
    } // @action sexChange = (event) => {
    //   this.gender = parseInt(event.target.value, 10);
    // }

  }, {
    key: "bmi",
    get: function get() {
      return (0, _bmi.bmi)(this.weightKg, this.heightCm);
    }
  }, {
    key: "bmiClass",
    get: function get() {
      return bmiClassification(this.bmi);
    }
  }, {
    key: "bmiClassRows",
    get: function get() {
      var result = [];

      for (var x in BmiClass) {
        if (typeof BmiClass[x] === "number") {
          result.push(createRowData(parseInt(BmiClass[x], 10)));
        }
      }

      return result;
    }
  }]);
  return BmiCalculator;
}(_react.Component), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "height", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 180;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "weight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 80;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "heightCm", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.height;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "weightKg", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.weight;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "unit", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return UnitType.Metric;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "heightValues", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "heightValues"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "weightValues", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "weightValues"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "heightDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "heightDisplay"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "weightDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "weightDisplay"), _class2.prototype), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "unitChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (event) {
      var newValue = event;

      if (newValue !== _this2.unit) {
        var fromHeightUnitType = _this2.heightValues.unitType;
        var fromWeightUnitType = _this2.weightValues.unitType;
        _this2.unit = newValue; // just  round to integer for now until we something more specific

        _this2.heightCm = convertLength(_this2.height, fromHeightUnitType, LengthUnit.cm);
        _this2.weightKg = convertWeight(_this2.weight, fromWeightUnitType, WeightUnit.kg);
        _this2.height = Math.round(convertLength(_this2.height, fromHeightUnitType, _this2.heightValues.unitType));
        _this2.weight = Math.round(convertWeight(_this2.weight, fromWeightUnitType, _this2.weightValues.unitType));
      }
    };
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "heightChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (event) {
      _this3.height = event; // TODO: this turned into a bit of a hack fest, should derive heightCm and weightKg

      _this3.heightCm = convertLength(_this3.height, _this3.heightValues.unitType, LengthUnit.cm);
    };
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "weightChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (event) {
      _this4.weight = event;
      _this4.weightKg = convertWeight(_this4.weight, _this4.weightValues.unitType, WeightUnit.kg);
    };
  }
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "bmi", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "bmi"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "bmiClass", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "bmiClass"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "bmiClassRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "bmiClassRows"), _class2.prototype)), _class2)) || _class;

exports.BmiCalculator = BmiCalculator;